import Toast from 'components/Toast';

const showFieldError = (fieldUtil, errMsg) => {
    if (!fieldUtil) {
        Toast.show(errMsg);
    } else {
        fieldUtil.$setError({ isError: errMsg });
    }
};

export default showFieldError;
